/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Role_LainnyaInputs */

const en_cp_role_lainnya = /** @type {(inputs: Cp_Role_LainnyaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const id_cp_role_lainnya = /** @type {(inputs: Cp_Role_LainnyaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lainnya`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Cp_Role_LainnyaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_role_lainnya = /** @type {((inputs?: Cp_Role_LainnyaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Role_LainnyaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_role_lainnya(inputs)
	return en_cp_role_lainnya(inputs)
});